import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <h1>Please be patient, the site is loading...</h1>
    </div>
  );
};

export default LoadingScreen;
